/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

export function useScrollPosition(enabled = true) {
  const [scrollPosition, setScrollPosition] = useState(0);
  const scroll80 = scrollPosition > 80;
  const scroll1k = scrollPosition > 1000;

  const handleScroll = () => {
    const position = window.pageYOffset;

    if (position > 80 && scrollPosition < 80) {
      setScrollPosition(position);
    }

    if (position < 80 && scrollPosition > 80) {
      setScrollPosition(position);
    }

    if (position > 1000 && scrollPosition < 1000) {
      setScrollPosition(position);
    }

    if (position < 1000 && scrollPosition > 1000) {
      setScrollPosition(position);
    }
  };

  useEffect(() => {
    if (!enabled) {
      return;
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [enabled, scrollPosition]);

  return {
    scroll80,
    scroll1k
  };
}
